{
  "name": "json-editor-vue",
  "PascalCasedName": "JsonEditorVue",
  "type": "commonjs",
  "version": "0.19.1",
  "private": false,
  "description": "Vue 2/3 isomorphic JSON editor, viewer, formatter and validator.",
  "author": {
    "name": "Cloyd Lau",
    "url": "https://github.com/cloydlau"
  },
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/cloydlau/json-editor-vue.git"
  },
  "keywords": [
    "ajv",
    "bigint",
    "edit",
    "format",
    "formatter",
    "json",
    "jsoneditor",
    "nuxt",
    "nuxtjs",
    "schema",
    "ssr",
    "svelte-jsoneditor",
    "validate",
    "validation",
    "validator",
    "view",
    "vue",
    "vue-demi",
    "vue-json-pretty",
    "vue-json-viewer"
  ],
  "exports": {
    ".": {
      "import": {
        "types": "./dist/json-editor-vue.d.mts",
        "default": "./dist/json-editor-vue.mjs"
      },
      "require": {
        "types": "./dist/json-editor-vue.d.ts",
        "default": "./dist/json-editor-vue.umd.js"
      }
    },
    "./*": "./*"
  },
  "main": "./dist/json-editor-vue.umd.js",
  "module": "./dist/json-editor-vue.mjs",
  "unpkg": "./dist/json-editor-vue.umd.js",
  "jsdelivr": "./dist/json-editor-vue.umd.js",
  "types": "./dist/json-editor-vue.d.ts",
  "files": [
    "dist",
    "docs",
    "nuxt.ts"
  ],
  "scripts": {
    "dev": "esno ./scripts/dev.mts",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "test:coverage:docs": "esno ./scripts/update-coverage-docs.mts",
    "test:ui": "vitest --ui",
    "doc": "vitepress dev --open /README",
    "typegen": "tsup --entry.json-editor-vue src/index.ts --format esm,cjs --cjsInterop --clean --dts-only",
    "build": "vite build && pnpm typegen",
    "attw": "attw --pack .",
    "release": "esno ./scripts/release.mts",
    "lint": "eslint \"**/*.{js,mjs,cjs,jsx,ts,mts,cts,tsx,vue,json,md,html,css,scss,sass}\"",
    "lint:fix": "eslint \"**/*.{js,mjs,cjs,jsx,ts,mts,cts,tsx,vue,json,md,html,css,scss,sass}\" --fix",
    "pnpm:devPreinstall": "pnpm dlx only-allow pnpm && pnpm config set registry https://registry.npmmirror.com",
    "postinstall": "simple-git-hooks && git config core.hooksPath .git/hooks/",
    "lint:inspect": "pnpm exec eslint-config-inspector"
  },
  "peerDependencies": {
    "@vue/composition-api": ">=1",
    "vue": "2||3"
  },
  "peerDependenciesMeta": {
    "@vue/composition-api": {
      "optional": true
    }
  },
  "dependencies": {
    "vanilla-jsoneditor": "^3.12.0",
    "vue-demi": "^0.14.10"
  },
  "devDependencies": {
    "@antfu/eslint-config": "^9.1.0",
    "@arethetypeswrong/cli": "^0.18.5",
    "@commitlint/cli": "^21.2.1",
    "@commitlint/config-conventional": "^21.2.0",
    "@eslint/config-inspector": "^3.1.0",
    "@eslint/eslintrc": "^3.3.6",
    "@types/cross-spawn": "^6.0.6",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^26.1.1",
    "@types/prompts": "^2.4.9",
    "@types/semver": "^7.7.1",
    "@vitejs/plugin-legacy": "^8.2.1",
    "@vitejs/plugin-vue": "^6.0.8",
    "@vitest/coverage-v8": "^4.1.10",
    "@vitest/ui": "^4.1.10",
    "@vue/compiler-sfc": "^3.5.40",
    "@vue/test-utils": "^2.4.11",
    "browserslist": "^4.28.6",
    "browserslist-to-esbuild": "^2.1.1",
    "case-police": "^2.2.1",
    "cnpm": "^9.4.0",
    "code-inspector-plugin": "^2.0.3",
    "cross-spawn": "^7.0.6",
    "del": "^8.0.1",
    "destr": "^2.0.5",
    "eslint": "^10.7.0",
    "eslint-plugin-financial": "^0.1.0",
    "eslint-plugin-format": "^2.0.1",
    "eslint-plugin-no-unsanitized": "^4.1.5",
    "esno": "^4.8.0",
    "happy-dom": "^20.11.0",
    "json-editor-vue": "workspace:*",
    "lint-staged": "^17.1.0",
    "lodash-es": "^4.18.1",
    "lossless-json": "^4.3.0",
    "magicast": "^0.5.3",
    "npm-check-updates": "^22.2.9",
    "prompts": "^2.4.2",
    "publint": "^0.3.21",
    "rollup-plugin-visualizer": "^7.0.1",
    "semver": "^7.8.5",
    "simple-git-hooks": "^2.13.1",
    "tsup": "^8.5.1",
    "typescript": "^5.9.3",
    "unplugin-auto-import": "^21.0.0",
    "unplugin-vue-components": "^32.1.0",
    "vite": "^8.1.5",
    "vitepress": "^1.6.4",
    "vitest": "^4.1.10",
    "vue": "^3.5.40",
    "vue-global-config": "^0.6.3",
    "zhlint": "^0.8.2"
  },
  "simple-git-hooks": {
    "pre-commit": "pnpm exec lint-staged",
    "commit-msg": "pnpm exec commitlint --edit ${1}"
  },
  "lint-staged": {
    "*.md": [
      "case-police --fix",
      "zhlint --fix"
    ],
    "docs/README.zh-CN.md": "zhlint --fix",
    "*.{js,mjs,cjs,jsx,ts,mts,cts,tsx,vue,json,md,html,css,scss,sass}": "eslint --cache --fix"
  },
  "browserslist": [
    "last 6 years",
    "last 2 major versions",
    "not dead",
    "> 0.2%",
    "chrome >= 87",
    "firefox >= 78",
    "firefox esr",
    "safari >= 14",
    "edge >= 88",
    "ios >= 12",
    "android >= 9"
  ]
}
